import React, { useLayoutEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import logo from '../../../../assets/center/images/logo-h.png';
import { setUserType } from '../../../../redux/slices/userType';
import { useDispatch } from 'react-redux';
import { setGlobalLoader } from '../../../../redux/slices/globalLoader';
import GlobalLoader from '../../../doctor/shared/globalLoader';
import { useSelector } from 'react-redux';

const SelectUser = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [selectedType, setSelectedType] = useState(null);

   const loaderState = useSelector((state) => state.globalLoader);

  useLayoutEffect(() => {
    dispatch(setUserType("center"));
    Promise.all([
      import("../../../../assets/center/css/style.css"),
    ]).then(() => {
      dispatch(setGlobalLoader(false));
    });
    // dispatch(setGlobalLoader(false));
  }, []);
  const handleSelection = () => {
    if (selectedType) {
      navigate(`/${selectedType}/login`, { state: { select_role: selectedType } });
    }
  };

  return (<>
  {loaderState ? (
    <GlobalLoader/>
  ):(
    <div className="d-flex justify-content-center align-items-center auth-body">
      <div className="auth-box text-center">
        {/* <div className='form-logo mb-5'>
      <img src={logo} alt="Logo" />
    </div> */}
        <div className='form-logo mb-5'>
          {/* <a href="https://healadmin.devtechnosys.tech/" target="_blank" rel="noopener noreferrer">
            <img src={logo} alt="Logo" />
          </a> */}
          <div className="form-logo mb-5">
            <a
              href={ window.location.origin}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={logo} alt="Logo" />
            </a>
          </div>
        </div>
        <div className='form-text '>
          <h5 class="mt-2">{t("center.login.select_type")}</h5>
        </div>

        <div className="mb-4 select-btns">
          <div className='row'>
            <div className='col-md-6'>
              {/* Center Card */}
              <div className={`user-type-card cursor-pointer ${selectedType === 'center' ? 'selected' : ''}`}
                onClick={() => setSelectedType('center')}

              >
                <svg width="100" height="101" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M51.9131 50.5H67.2174V81.1087H51.9131V50.5Z" fill="white" />
                  <path
                    d="M90.1739 81.1084V39.0215H9.82611V81.1084H28.9565V48.5867C28.9565 48.0793 29.1581 47.5927 29.5168 47.234C29.8756 46.8752 30.3622 46.6737 30.8696 46.6737H69.1304C69.6378 46.6737 70.1244 46.8752 70.4831 47.234C70.8419 47.5927 71.0434 48.0793 71.0434 48.5867V81.1084H90.1739Z"
                    fill="white" />
                  <path
                    d="M32.7826 50.5H48.0869V81.1086H32.7826V50.5ZM90.1738 25.6304H65.3043V10.3261C65.3033 9.31165 64.8999 8.33906 64.1825 7.62175C63.4652 6.90444 62.4926 6.50101 61.4782 6.5H38.5217C37.5073 6.50101 36.5347 6.90444 35.8174 7.62175C35.1001 8.33906 34.6966 9.31165 34.6956 10.3261V25.6304H9.82608C8.81165 25.6314 7.83906 26.0349 7.12175 26.7522C6.40444 27.4695 6.00101 28.4421 6 29.4565V31.3695C6.00101 32.384 6.40444 33.3566 7.12175 34.0739C7.83906 34.7912 8.81165 35.1946 9.82608 35.1956H90.1738C91.1883 35.1946 92.1609 34.7912 92.8782 34.0739C93.5955 33.3566 93.9989 32.384 93.9999 31.3695V29.4565C93.9989 28.4421 93.5955 27.4695 92.8782 26.7522C92.1609 26.0349 91.1883 25.6314 90.1738 25.6304ZM55.7391 21.8043H51.913V25.6304C51.913 26.1378 51.7114 26.6244 51.3527 26.9831C50.9939 27.3419 50.5073 27.5435 50 27.5435C49.4926 27.5435 49.006 27.3419 48.6472 26.9831C48.2885 26.6244 48.0869 26.1378 48.0869 25.6304V21.8043H44.2608C43.7535 21.8043 43.2669 21.6028 42.9081 21.244C42.5493 20.8853 42.3478 20.3987 42.3478 19.8913C42.3478 19.3839 42.5493 18.8973 42.9081 18.5386C43.2669 18.1798 43.7535 17.9783 44.2608 17.9783H48.0869V14.1522C48.0869 13.6448 48.2885 13.1582 48.6472 12.7994C49.006 12.4407 49.4926 12.2391 50 12.2391C50.5073 12.2391 50.9939 12.4407 51.3527 12.7994C51.7114 13.1582 51.913 13.6448 51.913 14.1522V17.9783H55.7391C56.2465 17.9783 56.733 18.1798 57.0918 18.5386C57.4506 18.8973 57.6521 19.3839 57.6521 19.8913C57.6521 20.3987 57.4506 20.8853 57.0918 21.244C56.733 21.6028 56.2465 21.8043 55.7391 21.8043ZM92.0869 84.9347H7.91304C7.40567 84.9347 6.91908 85.1363 6.56032 85.495C6.20155 85.8538 6 86.3404 6 86.8478V88.7608C6.00152 90.2824 6.60666 91.7413 7.68263 92.8173C8.75859 93.8932 10.2175 94.4984 11.7391 94.4999H88.2608C89.7824 94.4984 91.2413 93.8932 92.3173 92.8173C93.3932 91.7413 93.9984 90.2824 93.9999 88.7608V86.8478C93.9999 86.3404 93.7984 85.8538 93.4396 85.495C93.0808 85.1363 92.5942 84.9347 92.0869 84.9347Z"
                    fill="white" />
                </svg>


              </div>
              <div className='fw-bold'>{t("Center")}</div>
            </div>
            <div className='col-md-6'>
              {/* Doctor Card */}
              <div className={`user-type-card cursor-pointer ${selectedType === 'doctor' ? 'selected' : ''}`}
                onClick={() => setSelectedType('doctor')}
              >
                <svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M35.4166 70.8337C36.5672 70.8337 37.5 69.9009 37.5 68.7503C37.5 67.5997 36.5672 66.667 35.4166 66.667C34.2661 66.667 33.3333 67.5997 33.3333 68.7503C33.3333 69.9009 34.2661 70.8337 35.4166 70.8337Z" fill="#9E9E9E" />
                  <path d="M66.6667 50.1042V66.875C69.0195 67.3553 71.1342 68.6337 72.6527 70.494C74.1713 72.3542 75.0005 74.682 75 77.0833V81.25C75 82.3958 74.0625 83.3333 72.9167 83.3333H70.8333C68.0833 83.3333 68.0833 79.1667 70.8333 79.1667V77.0833C70.8333 73.6458 68.0208 70.8333 64.5833 70.8333C61.1458 70.8333 58.3333 73.6458 58.3333 77.0833V79.1667C61.0833 79.1667 61.0833 83.3333 58.3333 83.3333H56.25C55.1042 83.3333 54.1667 82.3958 54.1667 81.25V77.0833C54.1667 72.0625 57.75 67.8542 62.5 66.875V50.4792C50.7083 53.5417 41.5 51.5 37.5 50.4792V62.8958C39.9167 63.75 41.6667 66.0417 41.6667 68.7708C41.6667 72.2083 38.8542 75.0208 35.4167 75.0208C31.9792 75.0208 29.1667 72.2083 29.1667 68.7708C29.1667 66.0625 30.9167 63.7708 33.3333 62.8958V50.125C22.8125 51.1667 14.5833 60.0625 14.5833 70.8542V85.8958C14.5791 87.4318 15.1425 88.9153 16.1654 90.0612C17.1882 91.2071 18.5984 91.9347 20.125 92.1042C39.9375 94.3125 60.0625 94.3125 79.8958 92.1042C81.4187 91.9299 82.8238 91.2002 83.8424 90.0548C84.861 88.9094 85.4215 87.4286 85.4167 85.8958V70.8542C85.4167 60.0625 77.1875 51.1667 66.6667 50.125V50.1042ZM50 6.25C39.6667 6.25 31.25 14.6667 31.25 25C31.25 35.3333 39.6042 47.9167 50 47.9167C60.3958 47.9167 68.75 35.375 68.75 25C68.75 14.625 60.3333 6.25 50 6.25Z" fill="#9E9E9E" />
                </svg>



              </div>
              <div className='fw-bold'>{t("Doctor")}</div>
            </div>

          </div>



        </div>

        <button className="btn btn-primary px-5" onClick={handleSelection} disabled={!selectedType}>
          {t("center.login.btn_next")}
        </button>
      </div>
    </div>
  )}
    
    </>
  );
};

export default SelectUser;